import React from 'react';
import PageWrapper from './PageWrapper';
import Headline from './dom-elements/Headline';
import { heights, widths } from './../styles/theme.json';

const Error = () => {
  return (
    <PageWrapper>
      <section id={'error-content'}>
        <Headline color={'black'}>Error! Data Not Found.</Headline>
      </section>
      <style jsx>{`
        #error-content {
          width: 100%;
          height: 100vh;
          top: 0;
          left: 0;
          position: fixed;
          display: flex;
          align-items: center;
          justify-content: center;
        }
      `}</style>
    </PageWrapper>
  );
};

export default Error;


// WEBPACK FOOTER //
// ./src/components/Error.js